<mat-toolbar class="pre-auth-toolbar" fxLayout="row" fxLayoutAlign="space-between center">
  <img class="owner-logo btn-cursor ms-2" [src]="landlordLogo"
       alt="owner-logo">
</mat-toolbar>

<mat-progress-bar mode="indeterminate" *ngIf="loading$ | async"></mat-progress-bar>
